// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS:
//   ROOT: app/assets/webpack_entry/core_webpack.wjs.jsx
// MAGIC_DESPROCKET_END
(function() {
    var csrf_replacer = {
        page_loaded: function(placeholder) {
            if ($('meta[name=csrf-token]').attr('content') === placeholder) {
                $.post('/csrf_meta', function(data) {
                    $('meta[name=csrf-token]').attr('content', data);
                    $('input[name=authenticity_token]').val(data);
                });
            }
        }
    };
    $(document).ready(function() {
        if ("undefined" !== typeof $authenticity_token_placeholder) {
            csrf_replacer.page_loaded($authenticity_token_placeholder);
        }
    });
})();
